import { toast } from "sonner";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { money } from "@/components/deals/format";

export function ManualOfferDialog({ state, setState, onSaved }) {
  const [val, setVal] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (state.open) setVal(state.current != null ? String(state.current) : ""); }, [state.open, state.current]);
  const close = () => setState(s => ({ ...s, open: false }));
  const save = async (clear = false) => {
    const n = Number(val);
    if (!clear && (!Number.isFinite(n) || n <= 0)) { toast.error("Enter a positive number"); return; }
    setSaving(true);
    try {
      await api.setDealOffer(state.dealId, clear ? null : n);
      toast.success(clear ? "Offer reset to auto" : `Offer set to $${n.toFixed(2)}`);
      close(); onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
    setSaving(false);
  };
  return (
    <Dialog open={state.open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="bg-[#FFFFFF] border-[#E4E4E0] max-w-sm" data-testid="manual-offer-dialog">
        <DialogHeader>
          <DialogTitle className="font-head uppercase tracking-tighter">Adjust Offer · {state.setNumber}</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          <div className="font-mono text-[11px] text-gray-500">
            Auto offer: <span className="text-gray-800">{state.auto != null ? money(state.auto) : "--"}</span>
            {state.isManual && <span className="ml-2 text-[#E3000B]">· currently adjusted</span>}
          </div>
          <Label className="font-mono text-[10px] uppercase text-gray-500">Your offer ($)</Label>
          <Input type="number" step="0.01" min="0" value={val} onChange={(e) => setVal(e.target.value)} autoFocus
            onKeyDown={(e) => e.key === "Enter" && save()}
            className="bg-[#F6F6F3] border-[#E4E4E0] font-mono" data-testid="manual-offer-input" />
        </div>
        <DialogFooter className="gap-2">
          {state.isManual && (
            <Button variant="outline" onClick={() => save(true)} disabled={saving} data-testid="manual-offer-clear"
              className="border-[#E4E4E0] text-gray-800 font-mono text-xs">RESET TO AUTO</Button>
          )}
          <Button onClick={() => save(false)} disabled={saving} data-testid="manual-offer-save"
            className="bg-[#E3000B] text-white font-bold uppercase text-xs">SAVE</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

